import { Action, Types } from './types';

export interface SerialisableSet {
  [key: string]: true;
}

export interface Status {
  retrievingAll: boolean;
  saving: SerialisableSet;
}

export function statusReducer<T, S>(service: S) {
  const initialState: Status = {
    retrievingAll: false,
    saving: {},
  };

  return (state: Status = initialState, action: Action<T, S>): Status => {
    if (action.service !== service) {
      return state;
    }

    let saving;

    switch (action.type) {
      case Types.GET_COLLECTION_STARTED:
        return {
          ...state,
          retrievingAll: true,
        };

      case Types.GET_COLLECTION_COMPLETED:
      case Types.GET_COLLECTION_FAILED:
        return {
          ...state,
          retrievingAll: false,
        };

      case Types.CREATE_STARTED:
      case Types.UPDATE_STARTED:
      case Types.PATCH_STARTED:
        saving = { ...state.saving };
        saving[action.payload.id] = true;
        return {
          ...state,
          saving,
        };

      case Types.CREATE_COMPLETED:
        saving = { ...state.saving };
        delete saving[action.payload.tempId];
        return {
          ...state,
          saving,
        };

      case Types.CREATE_FAILED:
      case Types.UPDATE_FAILED:
      case Types.UPDATE_COMPLETED:
      case Types.PATCH_COMPLETED:
      case Types.PATCH_FAILED:
        saving = { ...state.saving };
        delete saving[action.payload.id];
        return {
          ...state,
          saving,
        };

      case Types.CLEAR_ALL:
        return initialState;

      default:
        return state;
    }
  };
}
